// src/menu-items/iconMap.js
import {
  HomeOutlined,
  SnippetsOutlined,
  CalendarOutlined,
  TeamOutlined,
  SkinOutlined,
  SmileOutlined,
  ShopOutlined,
  UserOutlined,
  PartitionOutlined,
  SignatureOutlined,
  LoginOutlined,
  ProfileOutlined,
  DashboardOutlined,
  AppstoreAddOutlined,
  BarcodeOutlined,
  BgColorsOutlined,
  FontSizeOutlined,
  LoadingOutlined,
  DislikeOutlined,
  AntDesignOutlined
} from '@ant-design/icons';

// OBJETO PLANO: claves = strings que vienen de la BD, valores = componentes
const iconMap = {
  HomeOutlined,
  SnippetsOutlined,
  CalendarOutlined,
  TeamOutlined,
  SkinOutlined,
  SmileOutlined,
  ShopOutlined,
  UserOutlined,
  PartitionOutlined,
  SignatureOutlined,
  LoginOutlined,
  ProfileOutlined,
  DashboardOutlined,
  AppstoreAddOutlined,
  BarcodeOutlined,
  BgColorsOutlined,
  FontSizeOutlined,
  LoadingOutlined,
  DislikeOutlined,
  AntDesignOutlined
};

export default iconMap;
